import { QueryClient } from '@tanstack/react-query';

import { ApiRequestError } from '@/lib/api/client';

/**
 * The portfolio content is static; the only server state is the contact
 * submission. Retries are therefore conservative — resending a message the user
 * wrote is worse than showing them an error they can act on.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: (failureCount, error) => {
          if (error instanceof ApiRequestError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
